import { __decorate, __metadata } from "tslib";
// NPM
import PageHeader from "@/components/page-header.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import Layout from "@/router/layouts/main.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { IntegrationConfigurationModel } from "@/store/models/organizationSetting/integrationConfigurations";
import { ConfigurationModel } from "@/store/models/organizationSetting/zohoConfigurations";
import { OrganizationSettings } from "@/store/modules/organizationSetting.module";
import { toaster } from "@/utilities/toaster";
import { setInteractionMode } from "vee-validate";
import { Component, Mixins, Prop } from "vue-property-decorator";
import EmptyProviderComponent from "./EmptyProviderComponent.vue";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let HRMSProviderComponent = /** @class */ (() => {
    let HRMSProviderComponent = class HRMSProviderComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.configuration = new ConfigurationModel();
            this.apiConfiguration = new IntegrationConfigurationModel();
            this.selectedProviderId = null;
            this.IsPageLoading = false;
        }
        get externalApiConfiguration() {
            return OrganizationSettings.externalApiConfiguration;
        }
        selected(providerId) {
            this.selectedProviderId = providerId;
            OrganizationSettings.GetZohoHRMSProviderDetails(providerId).then((res) => {
                if (res) {
                    if (this.externalApiConfiguration != null) {
                        this.configuration = this.parseConfig();
                    }
                }
            });
        }
        parseConfig() {
            var configs = new ConfigurationModel();
            if (this.externalApiConfiguration.configurations != "") {
                return (configs = JSON.parse(this.externalApiConfiguration.configurations));
            }
            else {
                return configs;
            }
        }
        ParseConfigurations() {
            this.apiConfiguration.providerId = this.selectedProviderId;
            const serialized = JSON.stringify(this.configuration);
            this.apiConfiguration.configurations = serialized;
        }
        SaveConfiguration() {
            this.validate("externalConfiguration").then((response) => {
                if (response) {
                    this.IsPageLoading = true;
                    this.ParseConfigurations();
                    OrganizationSettings.SaveExternalApiConfigurations(this.apiConfiguration).then((response) => {
                        if (response) {
                            toaster.ShowSuccess(response.successMessages[0]);
                            this.IsPageLoading = false;
                        }
                        else {
                            toaster.ShowError(response.warningMessages[0]);
                            this.IsPageLoading = false;
                        }
                    });
                }
            });
        }
        async created() {
            if (this.externalApiProviders && this.externalApiProviders.length > 0) {
                try {
                    const res = await OrganizationSettings.GetSelectedHRMSProvider();
                    if (res && res.externalApiConfiguration) {
                        this.selectedProviderId = res.externalApiConfiguration.providerId;
                        this.selected(this.selectedProviderId);
                        return;
                    }
                }
                catch (error) {
                    console.log('No HRMS configuration found, using default provider');
                }
                this.selectedProviderId = this.externalApiProviders.find((h) => h.providerType == 1).id;
                this.selected(this.selectedProviderId);
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], HRMSProviderComponent.prototype, "externalApiProviders", void 0);
    HRMSProviderComponent = __decorate([
        Component({
            name: "HRMSProviderComponent",
            components: {
                Layout,
                PageHeader,
                SectionLoader,
                EmptyProviderComponent,
            },
        })
    ], HRMSProviderComponent);
    return HRMSProviderComponent;
})();
export default HRMSProviderComponent;
